import { Result } from 'domain/types';
import { GenericClient } from 'use-case/genericClient';

export type GetUseCase<T, O> = (criteria: O) => Promise<Result<T>>;

const getGenericUseCase = <T, O>(implementation: (client: GenericClient<T, O>, criteria: O) => Promise<Result<T>>) => (
    client: GenericClient<T, O>
): GetUseCase<T, O> => (criteria: O) => implementation(client, criteria);

export default getGenericUseCase;
